var link_preview_default = {
  "fontElementMap": "vOQ7J",
  "linkPreview": "R-8jf",
  "linkPreviewImage": "ENy7D",
  "linkPreviewInfo": "A0bZe",
  "linkPreviewTitle": "xOQ5a",
  "ellipsis": "_19CAV",
  "linkPreviewDescription": "DwCIH",
  "linkPreviewUrl": "e3-gG"
};
export {
  link_preview_default as default
};
//# sourceMappingURL=link-preview-scss.js.map
